import React from 'react'
import '../styles/Asociarse.css'

const Asociarse = () => {
  return (
    <main className="asociarse-cont">
<h1>
ASOCIARSE
</h1>
<div className="asoc-divisor">

</div>
<section className="asoc-texto"  >   
<h2>
¿Cómo asociarse?
</h2>
<p>
Nuestra oficina de Promoción Institucional y Orientación es la encargada de darle la bienvenida y brindarle toda la información necesaria sobre cómo asociarse, cuotas, modos de pagos y las ventajas de pertenecer a la Asociación Socorros Mutuos «Fuerzas Armadas»
</p>
<p>
Usted podrá comunicarse telefónicamente o visitarnos en nuestra sede, para completar el formulario indicado. El trámite es muy sencillo y significa un vehículo hacia todos los beneficios que ofrecemos.
</p>
</section>


    </main>
  )
}

export default Asociarse